"use strict";
angular.module("internal.setup")
    .controller('InternalSetupReact', ['ngReactBridge', '$scope', '$stateParams',
        /**
         * @param {any} ngReactBridge
         * @param {Record<string, any>} $scope
         */
        function (ngReactBridge, $scope) {
            var resource = "imagetrend-lms-internal";
            var basename = "/";

            $scope.reactReady = false;
            ngReactBridge.initializeAsync(resource, basename).then(function () {
                $scope.reactReady = true;
                $scope.$apply();
            }).catch(function (err) {
                console.error("Failed to initialize", err);
                $scope.reactError = true;
                $scope.$apply();
            });
        }])
    .directive("setup", ["ngReactBridge", function (ngReactBridge) {
        var basename = "/";
        var portal = false;
        var renderFunc = imagetrend.lms.internal.renderInternalApp;
        var cleanupFunc = imagetrend.lms.internal.cleanupInternalApp;
        return ngReactBridge.createNgReactDirective(basename, portal, renderFunc, cleanupFunc);
    }]);